export default function generateUniqueId() {
  return Math.floor(Math.random() * Date.now());
}



// WEBPACK FOOTER //
// ./src/utils/generateUniqueId.js